export interface IFormElementData {
    id: number | null;
    form: string | null;
    title: string;
    tags: any[];
    type: FormElementType;
    weight: number;
    visibilityRuleSet: string[];
    params: FormElementData;
}

export class FormElement {
    id: number | null;
    uri: string;
    form: string | null;
    title: string;
    weight: number;
    params: FormElementData;
    tags: number[] = [];
    type: FormElementType = {
        id: 0,
        title: '',
        component: '',
    };
    visibilityRuleSetRefs: string[];
    loaded: boolean = false;
    visible: boolean = false;
    collapsed: boolean = true;

    constructor(data: IFormElementData) {
        this.id = data.id;
        this.uri = '/api/form_elements/' + data.id;
        this.form = data.form;
        this.title = data.title;
        this.weight = data.weight;
        this.type = new FormElementType(data.type);
        this.tags = data.tags.map((t: any) => t.id);
        this.params = new FormElementData(data.params ? data.params : {});
        this.visibilityRuleSetRefs = data.visibilityRuleSet;
    }
}

interface IFormElementOption {
    collapsed: boolean;
    description: string;
}

export class FormElementData {
    body: string;
    placeholder: string;
    min: number;
    max: number;
    options: any[];
    description: string;
    collapsed: boolean;
    isMultiple: boolean;

    constructor(params: any) {
        this.body = params.body || '';
        this.placeholder = params.placeholder || '';
        this.min = params.min || 0;
        this.max = params.max || 0;
        this.options = params.options
            ? params.options.map((option: IFormElementOption) => {
                  option.collapsed = option.collapsed || option.description !== '';
                  return option;
              })
            : [];
        this.collapsed = params.collapsed || false;
        this.isMultiple = params.isMultiple || false;
        this.description = params.description || '';
    }
}

interface IFormElementTagData {
    'id': number | null;
    '@id': string;
    'form': string | null;
    'title': string;
    'hex': string;
}

export class FormElementTag {
    id: number | null;
    uri: string;
    form!: string | null;
    title: string;
    hex: string;
    active: boolean;
    visible!: boolean;

    constructor(data: IFormElementTagData) {
        this.id = data.id;
        this.uri = data['@id'];
        this.form = data.form;
        this.title = data.title;
        this.hex = data.hex;
        this.active = false;
    }
}

interface IFormElementTypeData {
    id: number;
    title: string;
    component: string;
}

export class FormElementType {
    id: number;
    title: string;
    component: string;

    constructor(data: IFormElementTypeData) {
        this.id = data.id;
        this.title = data.title;
        this.component = data.component;
    }
}
